import { makeRequest } from "./api";

export const FetchReviews = async (page, limit) => {
  return makeRequest(
    `/api/admin/manage/reviews/fetch?page=${page}&limit=${limit}`
  );
};

export const SingleReview = async (reviewId) => {
  return makeRequest(`/api/admin/manage/reviews/single/${reviewId}`);
};

export const SearchReviews = async (keyword, page, limit) => {
  return makeRequest(
    `/api/admin/manage/reviews/search?key=${keyword}&page=${page}&limit=${limit}`
  );
};

export const DownloadCSV = async () => {
  return makeRequest("/api/admin/manage/reviews/download-csv");
};

export const ListingStatusUpdate = async (reviewId, description, rating) => {
  return makeRequest("/api/admin/manage/reviews/update", {
    method: "PUT",
    data: { reviewId, description, rating },
  });
};

export const UpdateStatus = async (reviewId, status) => {
  return makeRequest(`/api/admin/manage/reviews/update/status`, {
    method: "PUT",
    data: { reviewId, status },
  });
};

export const UpdateReview = async (reviewId, description, rating) => {
  return makeRequest(`/api/admin/manage/reviews/update`, {
    method: "PUT",
    data: { reviewId, description, rating },
  });
};

export const WriteReview = async (propertyId, description, rating) => {
  return makeRequest(`/api/admin/manage/reviews/write`, {
    method: "POST",
    data: { propertyId, description, rating },
  });
};
